import { Text } from "@clipboard-health/ui-react";
import { Badge, type SxProps } from "@mui/material";

interface CountDisplayBadgeProps {
  customSx?: SxProps;
  count: number;
  isLoading: boolean;
  hasNextPage: boolean;
}

export function CountDisplayBadge(props: CountDisplayBadgeProps) {
  const { customSx, isLoading, count, hasNextPage } = props;
  const shouldShowCount = count > 0;

  if (shouldShowCount && !isLoading) {
    return (
      <Badge
        color="error"
        badgeContent={
          <Text variant="caption" color="white">
            {count}
            {hasNextPage && "+"}
          </Text>
        }
        variant="standard"
        sx={{ ...customSx }}
      />
    );
  }

  return null;
}
